module.exports = __webpack_public_path__ + "17beda75f8cebd5a459875b7c4f85f72.svg";